/* GLITTER GURL ✦ Black November: build-your-bag page + checkout alerts.
   The offer: pay for N, get N free, from 2 paid, up to 5 free, mixed across everything.
   The discount function decides which items are free; nothing here ever says which. */
(function () {
  'use strict';
  if (!window.GG_BN) return;
  var GIFT_VARIANT = 46350770241671;
  var MAX_FREE = 5;
  var money = function (c) { return (window.GG && GG.money) ? GG.money(c) : '$' + (c / 100); };
  var LIVE = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  var BUILD = LIVE ? '/pages/build-your-bag' : '/pages/faq?view=build-your-bag';
  window.GG_BN_BUILD = BUILD;

  var NOUN = {
    'jelly-glow-eyeshadow': ['jelly glow', 'jelly glows'], 'glitter-jelly-lip-gloss': ['gloss', 'glosses'],
    'lip-stain-marker': ['marker', 'markers'], 'glitter-mascara': ['mascara', 'mascaras'],
    'glitter-eyeliner': ['eyeliner', 'eyeliners'], 'multichrome-eyeshadow-stick': ['stick', 'sticks']
  };
  window.GG_BN_NOUN = NOUN;
  var ONE_LINE = {
    'glitter-jelly-lip-gloss': 'glitter gloss that never feels sticky',
    'lip-stain-marker': 'waterproof lip stain, lasts all day',
    'jelly-glow-eyeshadow': 'one swipe of glitter, no glue',
    'glitter-mascara': 'glitter over your mascara, zero fallout',
    'glitter-eyeliner': 'waterproof glitter liner that shifts in the light',
    'multichrome-eyeshadow-stick': 'two colours in one swipe, waterproof'
  };
  var LIPS = ['glitter-jelly-lip-gloss', 'lip-stain-marker'];
  var EYES = ['glitter-mascara', 'jelly-glow-eyeshadow', 'glitter-eyeliner', 'multichrome-eyeshadow-stick'];
  var ALL = LIPS.concat(EYES);   // gloss, marker, then mascara straight under the marker

  function shop() { return (window.GG_SHOP && GG_SHOP.products) || {}; }

  /* ── the offer maths, same rule as the checkout function ── */
  function units(c) {
    var u = [];
    (c && c.items || []).forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT || !(it.price > 0)) return;
      for (var i = 0; i < it.quantity; i++) u.push({ key: it.key, price: it.price });
    });
    return u;
  }
  function calc(prices) {
    var n = prices.length, sorted = prices.slice().sort(function (a, b) { return a - b; });
    var free = n >= 3 ? Math.min(Math.floor(n / 2), MAX_FREE) : 0, save = 0, worth = 0;   // 3 items = 1 free (Ali 2026-11-03)
    for (var i = 0; i < n; i++) { worth += sorted[i]; if (i < free) save += sorted[i]; }
    return { n: n, free: free, paid: n - free, worth: worth, save: save, pay: worth - save };
  }
  function cartCalc(c) { return calc(units(c).map(function (u) { return u.price; })); }
  window.GG_BN_CALC = calc;
  window.GG_BN_CART_CALC = cartCalc;

  /* What to tell her next, from how many items are in her bag. */
  function nextStep(n) {
    // Only 1 item gets the warning (Ali 2026-11-03); everything else is a calm next step.
    if (n <= 0) return { line: 'pay for 2, get 2 free ✦ start with any product' };
    if (n === 1) return { warn: 'wait, you\'re leaving free items behind!', line: 'add 1 more item and get 2 free 🎁', short: 'add 1 more ✦ get 2 free' };
    var free = Math.min(Math.floor(n / 2), MAX_FREE);
    if (free >= MAX_FREE) return { line: '5 free unlocked ✦ the most per order, gurl 🎉', done: true };
    if (n === 2) return { line: 'add 2 more items and get 2 free 🎁', short: 'add 2 more ✦ get 2 free' };
    if (n % 2) return { line: 'your next item is free 🎁', short: 'next item is free' };
    return { line: 'from now on it\'s buy 1, get 1 free 🎁', short: 'now buy 1, get 1 free' };
  }
  window.GG_BN_NEXT = nextStep;

  /* ── shared bits ── */
  function toast(msg) {
    var t = document.getElementById('gg-bn-toast');
    if (!t) { t = document.createElement('div'); t.id = 'gg-bn-toast'; t.className = 'gg-bn-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 1800);
  }
  function add(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); })
      .then(function () { return window.__ggCartRefresh ? window.__ggCartRefresh() : fetch('/cart.js').then(function (r) { return r.json(); }); });
  }
  function getCart() { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }

  /* ── checkout alert: the loss she is about to walk away from ── */
  function gate(c, go) {
    var n = cartCalc(c).n, step = nextStep(n);
    if (!step.warn) return false;
    var key = 'gg_bn_gate_' + n;
    try { if (sessionStorage.getItem(key)) return false; sessionStorage.setItem(key, '1'); } catch (e) {}
    var m = document.getElementById('gg-bn-gate');
    if (!m) {
      m = document.createElement('div'); m.id = 'gg-bn-gate'; m.className = 'gg-bn-gate';
      m.innerHTML = '<div class="gg-bn-gate-card"><div class="gg-bn-gate-ic">⚠️</div><div class="gg-bn-gate-t"></div><div class="gg-bn-gate-m"></div>' +
        '<a class="gg-btn gg-bn-gate-yes" href="#">add more 🎁</a><button type="button" class="gg-bn-gate-no">no thanks, check out →</button></div>';
      document.body.appendChild(m);
    }
    m.querySelector('.gg-bn-gate-t').textContent = step.warn;
    m.querySelector('.gg-bn-gate-m').textContent = step.line;
    var yes = m.querySelector('.gg-bn-gate-yes');
    yes.href = BUILD;
    yes.onclick = function (e) {
      if (document.getElementById('gg-bnb')) { e.preventDefault(); m.hidden = true; var d = document.getElementById('gg-drawer-close'); if (d) d.click(); }
    };
    m.querySelector('.gg-bn-gate-no').onclick = function () { m.hidden = true; go(); };
    m.onclick = function (e) { if (e.target === m) m.hidden = true; };
    m.hidden = false;
    return true;
  }
  window.GG_BN_GATE = gate;

  /* ── the bag tracker, shared by build-your-bag and every product page ── */
  // What she actually pays. On the published site the cart already carries the discount; on the
  // unpublished draft the discount is not switched on yet, so we use the same maths the checkout will.
  function payOf(c) { return LIVE ? (c && c.total_price || 0) : cartCalc(c).pay; }
  function perks(c) {
    var pay = payOf(c);
    return { pay: pay, ship: pay >= 5000, shipGap: Math.max(0, 5000 - pay), gift: pay >= 6000, giftGap: Math.max(0, 6000 - pay) };
  }
  function badgesHtml(c) {
    var k = perks(c);
    return '<div class="gg-bnb-badges">' +
      (k.ship ? '<span class="gg-bnb-badge on">🚚 free delivery ✓</span>' : '<span class="gg-bnb-badge">🚚 ' + money(k.shipGap) + ' to free delivery</span>') +
      (k.gift ? '<span class="gg-bnb-badge on">🎁 free gift ✓</span>' : '<span class="gg-bnb-badge">🎁 ' + money(k.giftGap) + ' to a free gift</span>') +
      '</div>';
  }
  function removeVariant(c, variantId, label) {
    var line = (c && c.items || []).filter(function (it) { return it.variant_id === variantId && it.price > 0; })[0];
    if (!line) return Promise.resolve(c);
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 }) })
      .then(function () { return window.__ggCartRefresh ? window.__ggCartRefresh() : getCart(); })
      .then(function (nc) { toast('removed ✦ ' + (label || 'item')); return nc; });
  }
  // Two rows of 5 (Ali 2026-11-03): "you pay" on top, "on us" underneath. Which icons sit in the free
  // row is the checkout's own rule (cheapest units), so the tracker never disagrees with checkout.
  // The free delivery / free gift bar, the same one as the site's top bar (sparkling fill + 💋 that turns
  // into 🚚 / 🎁 at each milestone), shown inside the trackers and the popup (Ali 2026-11-03).
  function meterHtml(c) {
    var k = perks(c), pct = Math.max(4, Math.min(100, k.pay * 100 / 6000));
    var txt = k.gift ? 'free delivery + your free gift unlocked 💋'
      : k.ship ? 'free delivery unlocked 💋 ✦ ' + money(k.giftGap) + ' to a free gift'
      : 'free delivery ✦ ' + money(k.shipGap) + ' away ✦ free gift at $60';
    var SHIP = 5000 * 100 / 6000, atGift = pct >= 93, atShip = !atGift && Math.abs(pct - SHIP) < 7.5;
    return '<div class="gg-bnb-meter"><div class="gg-meters gg-meters-one">' +
      '<span class="gg-meter-label' + (k.ship ? ' is-done' : '') + '">' + txt + '</span>' +
      '<div class="gg-meter gg-meter-one">' +
        '<div class="gg-meter-fill" style="width:' + pct + '%"><span class="gg-meter-kiss">' + (atGift ? '🎁' : atShip ? '🚚' : '💋') + '</span></div>' +
        '<span class="gg-ms gg-ms-ship' + (k.ship ? ' done' : '') + (atShip ? ' is-under' : '') + '" style="left:83.333%"><i>🚚</i><b>$50</b></span>' +
        '<span class="gg-ms gg-ms-gift' + (k.gift ? ' done' : '') + (atGift ? ' is-under' : '') + '" style="left:100%"><i>🎁</i><b>$60</b></span>' +
      '</div></div></div>';
  }
  // Exactly the checkout function's choice: units in cart-line order, cheapest first, equal prices keep
  // their line order. Tracker, bag list and checkout therefore always mark the same items free.
  function markFree(us, n) {
    us.map(function (u, i) { return { i: i, p: u.price }; })
      .sort(function (a, b) { return a.p - b.p || a.i - b.i; })
      .slice(0, n).forEach(function (x) { us[x.i].free = true; });
  }
  function drawTracker(el, c, onChange) {
    var P = shop(), r = cartCalc(c), step = nextStep(r.n);
    var chips = {}, names = {}, kinds = {};
    Object.keys(P).forEach(function (h) { (P[h].variants || []).forEach(function (v) { chips[v.id] = v.chip; names[v.id] = v.title; kinds[v.id] = (NOUN[h] || [''])[0]; }); });
    var us = [];
    (c && c.items || []).forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT || !(it.price > 0)) return;
      for (var i = 0; i < it.quantity; i++) us.push({ id: it.variant_id, price: it.price, pic: chips[it.variant_id] || it.image, name: names[it.variant_id] || it.title, kind: kinds[it.variant_id] || '' });
    });
    markFree(us, r.free);
    us.reverse();   // show what she added first, first
    var paid = us.filter(function (u) { return !u.free; }), free = us.filter(function (u) { return u.free; });
    function cell(u, isFreeRow) {
      if (!u) return '<span class="gg-bnb-slot' + (isFreeRow ? ' fr' : '') + '">' + (isFreeRow ? '<i>🎁</i>' : '') + '</span>';
      return '<button type="button" class="gg-bnb-slot in' + (isFreeRow ? ' is-free' : '') + '" data-rm="' + u.id + '" data-nm="' + u.name + '" aria-label="remove ' + u.name + '">' +
        '<span class="gg-bnb-pic"' + (u.pic ? ' style="background-image:url(\'' + u.pic + '\')"' : '') + '></span><b>✕</b>' +
        (isFreeRow ? '<em>free</em>' : '') + '<span class="gg-bnb-lbl">' + u.kind + '<br>' + u.name + '</span></button>';
    }
    var rowPaid = '', rowFree = '';
    for (var i = 0; i < 5; i++) { rowPaid += cell(paid[i], false); rowFree += cell(free[i], true); }
    var extra = Math.max(0, paid.length - 5);
    var cells = '<div class="gg-bnb-rowlbl">you pay</div><div class="gg-bnb-row">' + rowPaid + '</div>' +
      '<div class="gg-bnb-rowlbl free">on us 🎁</div><div class="gg-bnb-row">' + rowFree + '</div>' +
      (extra ? '<div class="gg-bnb-rowlbl">+ ' + extra + ' more paid ✦ max 5 free per order</div>' : '');
    var sum = r.n
      ? '<div class="gg-bnb-sum"><span><b>' + r.n + '</b> in your bag ✦ you pay ' + (r.save ? '<s class="gg-bnb-was">' + money(r.worth) + '</s> ' : '') + '<b class="gg-bnb-now">' + money(r.pay) + '</b></span><span class="gg-bnb-sum-free">🎁 <b>' + r.free + '</b> free</span>' +
        (r.save ? '<span class="gg-bnb-sum-save">you\'re saving <b>' + money(r.save) + '</b></span>' : '<span class="gg-bnb-sum-save">' + (step.short || '') + '</span>') + '</div>'
      : '';
    el.innerHTML = sum + '<div class="gg-bnb-slots2">' + cells + '</div>' +
      '<div class="gg-bnb-lad-txt">' + step.line + '</div>' + (r.n ? '<div class="gg-bnb-lad-hint">tap an item to remove it</div>' : '') +
      meterHtml(c);
    el.querySelectorAll('[data-rm]').forEach(function (b) {
      b.onclick = function (e) {
        // the slim pinned bar never removes anything: a tap there just opens her bag (Ali 2026-11-03)
        if (el.classList.contains('stuck')) return;
        e.stopPropagation(); b.disabled = true;
        removeVariant(c, +b.getAttribute('data-rm'), b.getAttribute('data-nm')).then(function (nc) { if (onChange) onChange(nc); });
      };
    });
    return r;
  }

  /* ── product pages: the same tracker pinned to the top once her bag has something in it ── */
  // how far down the site's menu bar reaches right now (0 once it has scrolled off the screen)
  function hdrBottom() {
    var h = document.querySelector('.gg-sticky');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.top <= 1 && r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  function initPdpTracker() {
    if (document.getElementById('gg-bnb')) return;   // build your bag has its own tracker; every other page gets this one
    var el = document.createElement('div');
    el.className = 'gg-bnb-ladder stuck gg-pdp-tr'; el.hidden = true;
    el.setAttribute('role', 'button'); el.title = 'open your bag';
    // in the page flow right under the site header, then sticks just below the menu while the menu is
    // pinned (desktop) or at the very top once the menu scrolls away (phone). Never overlaps the menu.
    var hdr = document.querySelector('.gg-sticky');
    var anchor = hdr ? (hdr.closest('.shopify-section') || hdr) : null;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor.nextSibling); else document.body.insertBefore(el, document.body.firstChild);
    function place() { el.style.top = hdrBottom() + 'px'; }
    window.addEventListener('scroll', place, { passive: true }); window.addEventListener('resize', place);
    document.body.classList.add('gg-has-pdp-tr');   // the pinned bar replaces the site's own top bar here
    var lastN = 0;
    el.addEventListener('click', function () {
      if (lastN && window.GG_BN_BAG) { window.GG_BN_BAG(); return; }
      // empty bag: nothing to show or check out, so take her to start shopping instead
      var card = document.querySelector('#gg-tiers');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else window.location.href = BUILD;
    });
    var busy = false;
    function draw(c) {
      var r = drawTracker(el, c, draw);
      lastN = r.n;
      el.classList.toggle('is-empty', !r.n);
      // empty bag: just the offer line and the delivery / gift bar, always pinned
      if (r.n) el.insertAdjacentHTML('beforeend', '<div class="gg-pdp-open">tap to see your bag ✦ <b>check out →</b></div>');
      if (!r.n) el.innerHTML = '<div class="gg-pdp-empty">black november ✦ <b>buy 2, get 2 free</b> ✦ ends in <span class="gg-pdp-clock" data-gg-countdown></span></div>' + meterHtml(c);
      el.hidden = false;
      place();
    }
    function refresh() { if (busy) return; busy = true; getCart().then(function (c) { busy = false; draw(c); }, function () { busy = false; }); }
    // gg-theme.js calls __ggAnnounceRefresh every time the bag changes; ride on it.
    var prev = window.__ggAnnounceRefresh;
    window.__ggAnnounceRefresh = function () { if (prev) prev.apply(this, arguments); setTimeout(refresh, 50); };
    refresh();
  }

  /* ── product pages: after "add to bag", a popup with her bag, her saving and the next step ── */
  // yes → build your bag, no → straight to checkout, or a small link to the bag (Ali 2026-11-03).
  window.GG_BN_ADDED = function (title) {
    var m = document.getElementById('gg-bn-added');
    if (!m) {
      m = document.createElement('div'); m.id = 'gg-bn-added'; m.className = 'gg-bn-gate gg-bn-added';
      m.innerHTML = '<div class="gg-bn-gate-card"><button type="button" class="gg-bn-added-x" aria-label="close">✕</button>' +
        '<div class="gg-bn-added-t">🎉 added to your bag!</div>' +
        '<div class="gg-bnb-ladder gg-bn-added-tr"></div>' +
        '<a class="gg-btn gg-bn-gate-yes gg-bn-added-yes" href="#">yes! let me add more →</a>' +
        '<button type="button" class="gg-btn gg-bn-added-no">no thanks, check out →</button><div class="gg-bn-list"></div>' +
        '</div>';
      document.body.appendChild(m);
      var shut = function () { m.hidden = true; if (window.GG_BN_REFRESH) window.GG_BN_REFRESH(); };
      m.querySelector('.gg-bn-added-x').onclick = shut;
      m.onclick = function (e) { if (e.target === m) shut(); };
      // already on build your bag: "add more" just closes the popup
      m.querySelector('.gg-bn-added-yes').addEventListener('click', function (e) {
        if (document.getElementById('gg-bnb')) { e.preventDefault(); shut(); return; }
        // product page: under 4 of this product, stay here and keep picking shades; 4 or more, go mix (Ali 2026-11-03)
        var pd = document.getElementById('gg-product-data'), h = null;
        try { h = pd && JSON.parse(pd.textContent).handle; } catch (err) {}
        if (!h) return;
        e.preventDefault();
        var link = e.currentTarget;
        getCart().then(function (c) {
          var mine = (c.items || []).reduce(function (s, it) { return s + (it.handle === h && it.price > 0 ? it.quantity : 0); }, 0);
          if (mine >= 4) { window.location.href = link.href; return; }
          shut();
          var card = document.querySelector('#gg-tiers');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      m.querySelector('.gg-bn-added-no').onclick = function (e) { e.currentTarget.textContent = 'opening checkout ✦'; window.location.href = '/checkout'; };
    }
    m.querySelector('.gg-bn-added-t').textContent = title || '🎉 added to your bag!';
    m.querySelector('.gg-bn-added-yes').href = BUILD;
    var tr = m.querySelector('.gg-bn-added-tr');
    function draw(c) {
      var r = drawTracker(tr, c, draw);
      m.querySelector('.gg-bn-list').innerHTML = bagListHtml(c);
      if (!r.n) m.hidden = true;
    }
    getCart().then(function (c) { if (!cartCalc(c).n) { m.hidden = true; return; } draw(c); m.hidden = false; });
  };

  // her bag as a receipt: one line per item, shade + product, price on the right; free ones crossed + "free"
  function bagListHtml(c) {
    var P = shop(), hand = {}, nm = {}, us = [];
    Object.keys(P).forEach(function (h) { (P[h].variants || []).forEach(function (v) { hand[v.id] = h; nm[v.id] = v.title; }); });
    (c && c.items || []).forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT || !(it.price > 0)) return;
      for (var q = 0; q < it.quantity; q++) us.push({ id: it.variant_id, price: it.price, h: hand[it.variant_id] || it.handle, name: nm[it.variant_id] || it.variant_title || it.title });
    });
    var r = cartCalc(c);
    markFree(us, r.free);
    var rows = [], seen = {};
    us.forEach(function (u) {
      var k = u.id + (u.free ? 'f' : 'p');
      if (seen[k]) { seen[k].n++; return; }
      seen[k] = { n: 1, u: u }; rows.push(seen[k]);
    });
    rows.sort(function (a, b) { return (a.u.free ? 1 : 0) - (b.u.free ? 1 : 0); });
    var gift = (c && c.items || []).some(function (it) { return it.variant_id === GIFT_VARIANT; });
    return '<div class="gg-bn-list-t">your bag ✦ ' + r.n + ' item' + (r.n === 1 ? '' : 's') + '</div>' + rows.map(function (row) {
      var u = row.u, kind = (NOUN[u.h] || [''])[0];
      return '<div class="gg-bn-rc' + (u.free ? ' is-free' : '') + '"><span class="rc-n">' + u.name + (row.n > 1 ? ' <i>×' + row.n + '</i>' : '') +
        '<small>' + kind + '</small></span><span class="rc-p">' + (u.free ? '<s>' + money(u.price * row.n) + '</s><b>free</b>' : money(u.price * row.n)) + '</span></div>';
    }).join('') +
    (gift ? '<div class="gg-bn-rc is-free"><span class="rc-n">mystery gift 🎁<small>full size, our pick</small></span><span class="rc-p"><b>free</b></span></div>' : '') +
    '<div class="gg-bn-rc rc-tot"><span class="rc-n">you pay</span><span class="rc-p">' + (r.save ? '<s>' + money(r.worth) + '</s>' : '') + money(r.pay) + '</span></div>';
  }

  // the cart is hidden in this theme: "your bag" is this popup (Ali 2026-11-03)
  window.GG_BN_BAG = function () { window.GG_BN_ADDED('👜 your bag'); };

  /* ── links that point at the builder ── */
  function wireLinks() { document.querySelectorAll('[data-gg-build]').forEach(function (a) { a.setAttribute('href', BUILD); }); }

  /* ── build your bag page ── */
  function initBuilder() {
    var root = document.getElementById('gg-bnb');
    if (!root) return;
    var P = shop(), cart = null, tab = 'all';
    var ladder = document.getElementById('gg-bnb-ladder'), grid = document.getElementById('gg-bnb-grid');
    var sets = document.getElementById('gg-bnb-sets'), bar = document.getElementById('gg-bnb-bar');
    var tabs = root.querySelectorAll('[data-gg-tab]');

    function avail(h) { return ((P[h] || {}).variants || []).filter(function (v) { return v.available; }); }
    function pickV(h, i) { var a = avail(h); return a.length ? a[i % a.length] : null; }
    var READY = [
      { name: 'lip lover', sub: '2 glosses + 2 markers', items: [['glitter-jelly-lip-gloss', 0], ['glitter-jelly-lip-gloss', 1], ['lip-stain-marker', 0], ['lip-stain-marker', 1]] },
      { name: 'glitter eyes', sub: 'mascara + eyeliner + 2 jelly glows', items: [['glitter-mascara', 0], ['glitter-eyeliner', 0], ['jelly-glow-eyeshadow', 0], ['jelly-glow-eyeshadow', 1]] },
      { name: 'one of everything', sub: 'all 6 products, 1 of each', items: [['glitter-mascara', 0], ['multichrome-eyeshadow-stick', 0], ['glitter-eyeliner', 0], ['glitter-jelly-lip-gloss', 0], ['lip-stain-marker', 0], ['jelly-glow-eyeshadow', 0]], tag: 'best value' }
    ];

    function counts() {
      var m = {};
      (cart && cart.items || []).forEach(function (it) { m[it.variant_id] = (m[it.variant_id] || 0) + it.quantity; });
      return m;
    }

    function removeOne(variantId, label) { removeVariant(cart, variantId, label).then(function (c) { cart = c; renderAll(); }); }
    function renderLadder() { drawTracker(ladder, cart, function (c) { cart = c; renderAll(); }); }
    // tapping the top bar opens her bag, same popup as the product page (Ali 2026-11-03)
    ladder.style.cursor = 'pointer';
    ladder.addEventListener('click', function () {
      if (cartCalc(cart).n && window.GG_BN_BAG) window.GG_BN_BAG();
      else root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // after she edits the bag inside the popup, redraw this page
    window.GG_BN_REFRESH = function () { getCart().then(function (c) { cart = c; renderAll(); }); };

    function goCheckout(btn) {
      getCart().then(function (c) {
        cart = c;
        var go = function () { if (btn) { btn.disabled = true; btn.textContent = 'opening checkout ✦'; } window.location.href = '/checkout'; };
        if (!(window.GG_BN_GATE && window.GG_BN_GATE(c, go))) go();
      });
    }

    function renderBar() {
      var r = cartCalc(cart);
      bar.hidden = !r.n;
      if (!r.n) return;
      var k = perks(cart);
      bar.innerHTML = '<div class="gg-bnb-bar-txt">' +
          '<div class="gg-bnb-bar-row"><span>' + r.n + ' item' + (r.n > 1 ? 's' : '') + ' ✦ total</span><b>' + money(r.pay) + '</b>' +
            (r.save ? '<s>' + money(r.worth) + '</s>' : '') + '</div>' +
          '<div class="gg-bnb-bar-tags">' +
            (r.save ? '<em class="sv">you save ' + money(r.save) + '</em>' : '<em class="nx">' + (nextStep(r.n).short || '') + '</em>') +
            (k.ship ? '<em class="ok">🚚 free delivery</em>' : '') +
            (k.gift ? '<em class="ok">🎁 free gift</em>' : '') +
          '</div></div>' +
        '<button type="button" class="gg-btn gg-bnb-bar-btn">checkout →</button>';
      var btn = bar.querySelector('button');
      btn.onclick = function () { goCheckout(btn); };
    }

    function renderSets() {
      if (!sets) return;   // ready-made bags removed (Ali 2026-11-03): she builds her own mix
      sets.innerHTML = '';
      READY.forEach(function (s) {
        var vs = s.items.map(function (x) { var v = pickV(x[0], x[1]); return v ? { h: x[0], v: v } : null; }).filter(Boolean);
        if (vs.length !== s.items.length) return;
        var r = calc(vs.map(function (x) { return P[x.h].price; }));
        var card = document.createElement('div'); card.className = 'gg-bnb-set';
        card.innerHTML = (s.tag ? '<span class="gg-bnb-tag">' + s.tag + '</span>' : '') +
          '<div class="gg-bnb-set-imgs">' + vs.map(function (x) { var g = (x.v.gallery || [])[0]; return '<span style="background-image:url(\'' + ((g && (g.src || g)) || x.v.chip || P[x.h].image) + '\')"></span>'; }).join('') + '</div>' +
          '<div class="gg-bnb-set-name">' + s.name + '</div><div class="gg-bnb-set-sub">' + s.sub + '</div>' +
          '<div class="gg-bnb-set-price"><b>' + money(r.pay) + '</b> <s>' + money(r.worth) + '</s> <em>' + r.free + ' free</em></div>' +
          '<button type="button" class="gg-btn gg-bnb-set-btn">add all ' + r.n + ' ✦ ' + money(r.pay) + '</button>';
        card.querySelector('button').onclick = function (e) {
          var b = e.currentTarget; b.disabled = true; b.textContent = 'adding ✦';
          var m = {}; vs.forEach(function (x) { m[x.v.id] = (m[x.v.id] || 0) + 1; });
          add(Object.keys(m).map(function (id) { return { id: +id, quantity: m[id] }; }))
            .then(function (c) { cart = c; renderAll(); renderSets(); toast(s.name + ' added ✦ ' + r.n + ' items'); })
            .catch(function (er) { alert((er && er.description) || 'something went wrong, gurl. try again?'); renderSets(); });
        };
        sets.appendChild(card);
      });
    }

    // Each card has a photo carousel. By default it shows one worn photo per shade (on eyes or lips),
    // each labelled with its shade, and as she swipes the matching shade circle lights up (not selected).
    // Tapping a shade selects it, adds it, and swaps the carousel to that shade's full gallery.
    var picked = {};
    function src(g) { return g && (g.src || g) || ''; }
    function slidesFor(h, vid) {
      var vs = (P[h] || {}).variants || [];
      if (vid) {
        var v = vs.filter(function (x) { return x.id === vid; })[0];
        if (v) {
          var g = (v.gallery || []).map(src).filter(Boolean);
          if (v.worn) g = [v.worn].concat(g.filter(function (u) { return u !== v.worn; }));
          if (g.length) return g.map(function (u) { return { u: u, name: v.title }; });
        }
      }
      return vs.map(function (x) { return { u: x.worn || src((x.gallery || [])[0]) || x.chip, name: x.title, peek: true }; });
    }
    function carousel(h, vid, inBag, onSlide) {
      var sl = slidesFor(h, vid);
      var el = document.createElement('div'); el.className = 'gg-bnb-car';
      el.innerHTML = '<div class="gg-bnb-track">' + sl.map(function (s) {
          return '<div class="gg-bnb-slide" style="background-image:url(\'' + s.u + '\')"><span class="gg-bnb-shade">' + s.name + '</span></div>';
        }).join('') + '</div>' +
        (inBag ? '<span class="gg-bnb-inbag">' + inBag + ' in bag</span>' : '') +
        (sl.length > 1 ? '<button type="button" class="gg-bnb-nav prev" aria-label="previous photo">‹</button><button type="button" class="gg-bnb-nav next" aria-label="next photo">›</button>' +
          '<div class="gg-bnb-dots">' + sl.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>' : '');
      var track = el.querySelector('.gg-bnb-track'), dots = el.querySelectorAll('.gg-bnb-dots i'), last = -1;
      function at() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function moved() {
        var k = at(); if (k === last) return; last = k;
        dots.forEach(function (d, i) { d.classList.toggle('on', i === k); });
        if (onSlide && !vid) onSlide(k);
      }
      track.addEventListener('scroll', moved, { passive: true });
      setTimeout(moved, 0);
      var pv = el.querySelector('.prev'), nx = el.querySelector('.next');
      if (pv) pv.onclick = function () { var k = at() - 1; if (k < 0) k = sl.length - 1; track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); };
      if (nx) nx.onclick = function () { var k = at() + 1; if (k >= sl.length) k = 0; track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); };
      return el;
    }

    function renderGrid() {
      var cm = counts(), list = tab === 'lips' ? LIPS : tab === 'eyes' ? EYES : ALL;
      grid.innerHTML = '';
      list.forEach(function (h) {
        var p = P[h]; if (!p) return;
        var inBag = 0; (p.variants || []).forEach(function (v) { inBag += cm[v.id] || 0; });
        var card = document.createElement('div'); card.className = 'gg-bnb-card';
        card.appendChild(carousel(h, picked[h], inBag, function (k) {
          card.querySelectorAll('.gg-bnb-chip').forEach(function (c, i) { c.classList.toggle('peek', i === k); });
        }));
        var info = document.createElement('div'); info.className = 'gg-bnb-info';
        var chosen = (p.variants || []).filter(function (v) { return v.id === picked[h]; })[0];
        info.innerHTML = '<div class="gg-bnb-name">' + p.title + '</div>' +
          '<div class="gg-bnb-line">' + (ONE_LINE[h] || '') + '</div><div class="gg-bnb-price">' + money(p.price) + ' each' +
          (chosen ? ' <span class="gg-bnb-showing">✦ showing ' + chosen.title + '</span>' : '') + '</div>' +
          '<div class="gg-bnb-hint">tap to add ✦ − to remove</div><div class="gg-bnb-chips"></div>';
        card.appendChild(info);
        var chips = info.querySelector('.gg-bnb-chips');
        (p.variants || []).forEach(function (v) {
          var wrap = document.createElement('div');
          wrap.className = 'gg-bnb-chip' + (v.available ? '' : ' out') + (cm[v.id] ? ' has' : '') + (picked[h] === v.id ? ' sel' : '');
          var b = document.createElement('button'); b.type = 'button'; b.className = 'gg-bnb-add';
          b.setAttribute('aria-label', 'add ' + v.title);
          b.innerHTML = '<span class="gg-bnb-sw"' + (v.chip ? ' style="background-image:url(\'' + v.chip + '\')"' : '') + '>' +
            (cm[v.id] ? '<i>' + cm[v.id] + '</i>' : '') + '</span><span class="gg-bnb-sn">' + v.title + '</span>';
          if (!v.available) b.disabled = true;
          else b.onclick = function () {
            picked[h] = v.id;
            var old = card.querySelector('.gg-bnb-car');
            if (old) card.replaceChild(carousel(h, v.id, inBag + 1), old);
            wrap.classList.add('busy');
            add([{ id: v.id, quantity: 1 }]).then(function (c) {
              cart = c; renderAll();
              var s = nextStep(cartCalc(c).n);
              toast('added ✦ ' + v.title + (s.short ? ' ✦ ' + s.short : ''));
            }).catch(function (er) { wrap.classList.remove('busy'); alert((er && er.description) || 'something went wrong, gurl. try again?'); });
          };
          wrap.appendChild(b);
          if (cm[v.id]) {
            var mn = document.createElement('button'); mn.type = 'button'; mn.className = 'gg-bnb-min';
            mn.setAttribute('aria-label', 'remove one ' + v.title); mn.textContent = '−';
            mn.onclick = function () { wrap.classList.add('busy'); removeOne(v.id, v.title); };
            wrap.appendChild(mn);
          }
          chips.appendChild(wrap);
        });
        grid.appendChild(card);
      });
    }

    function renderAll() { renderLadder(); renderBar(); renderGrid(); }
    tabs.forEach(function (t) {
      t.onclick = function () {
        tab = t.getAttribute('data-gg-tab');
        tabs.forEach(function (x) { x.classList.toggle('on', x === t); });
        renderGrid();
      };
    });
    // The WhatsApp bubble floats bottom-right; lift it above the checkout bar on this page.
    function liftChat() {
      document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"]').forEach(function (el) {
        for (var n = el; n && n !== document.body; n = n.parentElement) {
          if (getComputedStyle(n).position === 'fixed') { n.style.setProperty('bottom', '104px', 'important'); break; }
        }
      });
    }
    liftChat(); setTimeout(liftChat, 2500);
    // Once she scrolls past it, the tracker shrinks to a slim strip so it never covers the shades.
    var sentinel = document.createElement('div'); sentinel.style.height = '1px';
    ladder.parentNode.insertBefore(sentinel, ladder);
    // The full tracker keeps its space in the page (the sentinel takes its height) and a slim copy
    // floats at the top, so the page never jumps while she scrolls.
    // The slim strip only takes over once the full tracker is completely out of view, and gives way
    // as soon as its space scrolls back in, so there is never an empty block on screen.
    var fullH = 0;
    function setStuck(on) {
      if (on === ladder.classList.contains('stuck')) return;
      if (on) { fullH = ladder.offsetHeight; sentinel.style.height = fullH + 'px'; ladder.classList.add('stuck'); }
      else { ladder.classList.remove('stuck'); sentinel.style.height = '1px'; ladder.style.top = ''; }
    }
    function check() {
      var top = sentinel.getBoundingClientRect().top, h = ladder.classList.contains('stuck') ? fullH : ladder.offsetHeight;
      setStuck(top + h < hdrBottom());
      if (ladder.classList.contains('stuck')) ladder.style.top = hdrBottom() + 'px';   // under the menu, never over it
    }
    window.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check);
    renderSets();
    getCart().then(function (c) { cart = c; renderAll(); });
    // the drawer can change the bag too
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#gg-drawer')) setTimeout(function () { getCart().then(function (c) { cart = c; renderAll(); }); }, 900);
    });
  }

  // Coming back from checkout with the browser's back button restores a frozen page (buttons stuck on
  // "opening checkout"). Reload it so every button and the bag are fresh.
  window.addEventListener('pageshow', function (e) { if (e.persisted) window.location.reload(); });
  function boot() { wireLinks(); if (window.GG_BOX) return; initBuilder(); initPdpTracker(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
